<template>
  <div v-if="resource">
    <FormSection title="Empfehlungen">
      <template #text>
        Passe die Empfehlungen für Methoden im Studio an deine aktuelle Wachstumsphase und Bedürfnisse an
      </template>
      <template #form>
        <StageForm :resource="resource" :errors="errors" />
      </template>
    </FormSection>
    <FormButtons>
      <div class="space-x-2">
        <BackButton />
        <SubmitButton @click="onSubmit" :load="updating" :success="success">
          Aktualisieren
        </SubmitButton>
      </div>
    </FormButtons>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useRetrieveResource } from '@/client/actions';
import { useUpdateResource } from '@/client/actions';

const store = useStore();
const router = useRouter();

const parent = computed(() => store.getters['context/context'].id);

const retrieveTarget = computed(() => '/api/podcasts/' + parent.value + '/stage');

const convertFn = (x) => {
  return {commitment: x.commitment.key,  expansion:x.expansion.key,  investment: x.investment.key};
}

const retrieveAction = useRetrieveResource(retrieveTarget, {}, convertFn);

const { retrieve, retrieving, resource } = retrieveAction;

const updateTarget = computed(() => '/api/podcasts/' + parent.value + '/stage');

const updateAction = useUpdateResource(updateTarget, resource);

const { update, updating, errors, message, success } = updateAction;

const onMount = onMounted(() => retrieve());
const onSuccess = () => null; // TODO
const onSubmit = () => update(onSuccess);
</script>
